<template>
    <div class="mb-4"
         v-if="vserverC && vserverC.status">
<!--      <b-card class="mb-4 text-center" style="min-width: 300px; height: 20px;">-->
      <div class="header">
        <b-row >
          <b-col class="col-2">
          </b-col>
          <b-col class="col-8">
            <div v-if="this.vserverC && this.vserverC.status.status !== 'stopped'"
                 class="inline mt-1">
              <h3>
                <i class="mr-3 fa fa-circle" :style="statusColor"></i>
                {{this.vserverC && this.vserverC.status.status !== 'stopped' ? 'online' : 'offline'}}
                <b v-if="timedifference.hours > 24 ">
                  {{$moment.duration(vserverC.status.uptime,'seconds').humanize()}}
                </b>
                <b>
                  {{ timedifference.hours - (timedifference.days * 24) || timedifference.hours }}
                </b> :
                <b>
                  {{(timedifference.minutes - (timedifference.hours * 60)).toString().length <= 1 ?0:''}}{{timedifference.minutes - (timedifference.hours * 60) || timedifference.minutes }}
                </b> :
                <b v-if="secondsC - (timedifference.minutes * 60) > 0">
                  {{ (secondsC - (timedifference.minutes * 60)).toString().length <=1 ? 0:''}}{{ secondsC - (timedifference.minutes * 60)}}
                </b>
                <b v-else>
                  <b-spinner type="grow" class="mb-1" style="max-height: 12px; max-width: 12px;vertical-align: center;"></b-spinner>
                </b>
              </h3>
            </div>
            <div v-else
                 class="inline mt-1">
              <h3>
                <i class="mr-3 fa fa-circle" :style="statusColor"></i>
                offline
              </h3>
            </div>
          </b-col>
          <b-col class="col-2" >
            <b-button v-if=" this.vserverC && this.vserverC.status.status !== 'stopped'"
                      variant="default"
                      @click="start_stop.stop.func"
                      class="float-right">
                      Stop
            </b-button>
            <b-button v-else
                      variant="default"
                      @click="start_stop.start.func"
                      class="float-right">
                      Start
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-card-group deck v-if="vserverC">
        <div class="card text-center m-4 bg-dark text-white">
          <div class="card-img-overlay">
            <div style="font-size: 400%; float:left;" class="fa fa-info"></div>
            <p class="">{{vserverC.hostname}}</p>
            <b>ID: {{vserverC.id}}</b>
          </div>
        </div>
        <div  v-for="(item,key) in filter"
              :key="key"
              v-if="basic.includes(key)"
              class="card text-center m-4 ">
            <div class="m-2">
              <b>{{ vserverC[key] }} {{units[key]}}</b>
              <p>{{$t('vservers.general')[key]}}</p>
              <img :src="graphic[key]" height="25px">
            </div>
        </div>
      </b-card-group>
    </div>
</template>

<script>
  import {Vserver} from "@/store/models/vserver/vserver";
  import {VserverGraphic} from "@/mixins/vserver_graphic";
  import axios from "@/store/vue-axios"
  import {PageControl} from "@/store/models/layout/page_control";
  import {VserverGraph} from "@/store/models/vserver/vserver_graph";

  export default {
    name: "luma-single-vserver",
    mixins:[VserverGraphic],
    data:()=>({
      live_status_timer:null,
      live_status_func:null,
      timer:null,
      timeCounter:null,
      counter:0,
      seconds:0,
      basic:['cores','memory','disk'],
      details:[],
      units:{
        memory:'MB',
        disk:'GB'
      },
      vserver:{},

    }),

    computed:{
      check_update_live_staus(){
          const selected_timeframe = PageControl.find(this.$route.name).selected.time
          return selected_timeframe === 'live' ? 'live' : undefined
      },
      start_stop(){
        return {
          start:{
            name:'Start',
            icon:'fa fa-play',
            description:'Vserver starten',
            func:()=> {
               axios.post("/datacenter/vservers/"+this.vid+"/start")
            }
          },
          stop:{
            name:'Stop',
            icon:'fa fa-stop',
            description:'Vserver stoppen',
            func: ()=> {
              axios.post("/datacenter/vservers/"+this.vid+"/stop")
            }
          }
        }
      },
      statusColor(){
        return {
          color: this.vserverC && this.vserverC.status.status !== 'stopped' ? 'greenyellow' : 'red'
        }
      },
      graphic(){
        return VserverGraphic
      },
      vid(){
        return this.$route.params.id
      },
      vserverC(){
        if(!Vserver.all().length) return
        if(!Vserver.find(this.vid)) return
        this.vserver = Object.assign({},Vserver.find(this.vid))
        return this.vserver
      },
      filter(){
        const x = new Vserver
        return x
      },
      uptime(){
        return this.counter || 0
      },
      secondsC(){
          return this.seconds
      },
      timedifference(){
          return {
              seconds:this.$moment().add(this.vserverC.status.uptime,'seconds').diff(this.$moment(),'seconds') ,
              minutes:this.$moment().add(this.vserverC.status.uptime,'seconds').diff(this.$moment(),'minutes') ,
              hours:this.$moment().add(this.vserverC.status.uptime,'seconds').diff(this.$moment(),'hours'),
              days:this.$moment().add(this.vserverC.status.uptime,'seconds').diff(this.$moment(),'days'),
              months:this.$moment().add(this.vserverC.status.uptime,'seconds').diff(this.$moment(),'months')
          }
      }
    },
      methods:{

        refresh(){
            this.counter = 0
            this.seconds = this.timedifference.seconds
            this.timeCounter ? clearInterval(this.timeCounter) : undefined
            Vserver.fetchStatus(this.vid)
            this.counter =  this.vserverC && this.vserverC.status
              ?  this.timedifference.seconds
              : 0
            this.timeCounter = setInterval(()=>{
              this.counter++
              this.seconds++
            },1000)
            console.log('REFRESH')
        },
        createLiveSets(){
            VserverGraph.getGraph(this.vid,'AVERAGE','live',Date.now())
            VserverGraph.getGraph(this.vid,'MAX','live',Date.now())
        },
        updateLiveStatus(){
            // this.check_update_live_staus === 'live' ? this.createLiveSets() : undefined
            this.createLiveSets()
        }
      },
      mounted(){

      },
      created(){
        this.refresh()
        this.createLiveSets()
        this.updateLiveStatus()
        this.timer = setInterval(this.refresh,10000)
        this.live_status_timer = setInterval(this.updateLiveStatus,5000)
      },
      beforeDestroy() {
        clearInterval(this.timer)
        clearInterval(this.live_status_timer)
        this.timer=null
        this.live_status_timer = null
      }
  }
</script>

<style scoped>
  .min-width{
    min-width: 200px;
  }
  .card{
    min-height: 100px;
    min-width: 100px;
  }
  .header{
    background:white;
    margin: 8px;
    padding-top: 8px;
    padding-bottom: 4px;
    padding-right: 8px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/datacenter/vserver_datacenter/luma-single-vserver.vue